import { createStackNavigator } from "@react-navigation/stack";
import { NavBar } from "./NavBar";
import { navigationStore } from "../../../app/stores/Navigation";
import { useScreenComponent } from "../../../app/hooks/custom/useScreenComponent";
import { useComponentMount } from "../../../services/InitializationService";
import { ScreenComponent } from "../../../models/enums/ScreenComponents";

const Stack = createStackNavigator();

// Screen components that are handled via profile drawer, not as standalone screens
const drawerOnlyScreens = [ScreenComponent.Login, ScreenComponent.Register];

// Filter out any invalid/removed screen components from persisted storage
const validScreenComponents = Object.values(ScreenComponent).filter(
	screen => !drawerOnlyScreens.includes(screen)
);

export const BarNavigation = () => {
	useComponentMount('BarNavigation');
	const { screenList, currentScreen, screenDisplayNames } = navigationStore((state) => state);
	const { getScreenComponent } = useScreenComponent();

	// Filter screenList to only include valid screen components (excluding drawer-only screens)
	const validScreenList = screenList.filter(screen => 
		validScreenComponents.includes(screen)
	);

	// Ensure currentScreen is valid, fallback to Shop
	const validCurrentScreen = validScreenComponents.includes(currentScreen) 
		? currentScreen 
		: ScreenComponent.Shop;

	return (
		<>
			<NavBar
				align='flex-start'
				screens={validScreenList}
			/>
			<Stack.Navigator
				initialRouteName={validCurrentScreen.toString()}
				screenOptions={{
					headerShown: false,
				}}
			>
			{
				validScreenList.map((screen, index) => {
					const ScreenComp = getScreenComponent(screen);
					// Skip rendering if component is undefined (safety check)
					if (!ScreenComp) {
						console.warn(`[BarNavigation] Skipping undefined screen: ${screen}`);
						return null;
					}
					const displayName = screenDisplayNames[screen] || screen.replaceAll('_', ' ').toString();
					return (
						<Stack.Screen
							key={index}
							name={screen.toString()}
							component={ScreenComp}
							options={{ title: displayName }}
						/>
					);
				}).filter(Boolean)
			}
			</Stack.Navigator>
		</>
	);
};
